let accountId = null;
let revision = 0;
let requestId = 0;
let lastResponse = 0;
let queue = Promise.resolve();

function write(count, userId, currentRevision) {
  queue = queue.catch(() => {}).then(async () => {
    if (revision !== currentRevision || accountId !== userId) return;
    try {
      if (count > 0 && typeof navigator.setAppBadge === 'function') await navigator.setAppBadge(count);
      else if (typeof navigator.clearAppBadge === 'function') await navigator.clearAppBadge();
      else if (typeof navigator.setAppBadge === 'function') await navigator.setAppBadge(0);
    } catch (_) { /* Badges are optional and must not interrupt chat or login. */ }
  });
}
export function setBadgeAccount(id) {
  const next = id == null ? null : Number(id);
  if (accountId === next) return;
  accountId = next;
  lastResponse = 0;
  navigator.serviceWorker?.controller?.postMessage({type:'aeonas-badge-clear'});
  write(0, next, ++revision);
}
export function clearSignedOutBadge() {
  accountId = null;
  lastResponse = 0;
  navigator.serviceWorker?.controller?.postMessage({type:'aeonas-badge-clear'});
  write(0, null, ++revision);
}
export function beginBadgeRequest() { return ++requestId; }
export function syncAppIconBadge(count, userId, responseId) {
  if (accountId !== Number(userId) || responseId < lastResponse) return;
  lastResponse = responseId;
  const safeCount = Math.max(0, Math.floor(Number(count) || 0));
  write(safeCount, accountId, ++revision);
}
